import React from "react";
import PropTypes from "prop-types";
import StyledFilterTypeCheckbox from "./FilterTypeCheckboxEverscore.styled";
import SVGIcon from "../utility/SVGIcon";

const FilterTypeCheckboxEverscore = React.memo(props => {
  const { types, name, checkFilter, checked, disabled } = props;
  return (
    <StyledFilterTypeCheckbox className={`filter-product-type__checkbox ${checked && "is-checked"} filter-product-type__checkbox__svg-not-cheched`}>
      <input disabled={disabled} checked={checked} onChange={() => checkFilter(types.uri_param, name, types.name)} aria-label={name} type="checkbox" />
      <span className="filter-product-type__checkbox__custom">
        {
            checked ?
                <div className='filter-product-type__checkbox-border'>
                    <SVGIcon name="filter-check" className="filter-product-type__checkbox__svg-checked"/>
                </div> :
                <SVGIcon name="filter-checkbox"/>
        }
      </span>
      <p className="t-title-small filter-product-type__checkbox__copy">{types.name}</p>
    </StyledFilterTypeCheckbox>
  );
});

FilterTypeCheckboxEverscore.propTypes = {
  types: PropTypes.object.isRequired,
  checkFilter: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FilterTypeCheckboxEverscore;